<template>
    <textarea-field :value="value"
                    :options="options"
                    @enter="$emit('enter')"
                    @input="$emit('input', $event)"
                    @click="$emit('click')"
                    @focus="$emit('focus')"
                    @blur="$emit('blur')"
                    @keyup.ctrl.enter="$emit('enter')"
                    @invalid="$emit('invalid', $event)"
    ></textarea-field>
</template>

<script>
    import TextareaField from "./TextareaField";
    export default {
        name: 'resizable-textarea',
        components: {TextareaField},
        props: {
            options: Object,
            value: String,
            focusOnMount: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            resizeTextarea (event) {
                event.target.style.height = 'auto';
                event.target.style.height = (event.target.scrollHeight) + 'px'
            },
            handleEnter() {
                //console.log('enter')
            }
        },
        mounted () {
            this.$nextTick(() => {
               this.$el.setAttribute('style', 'height:' + (this.$el.scrollHeight) + 'px;')
            });
            this.$el.addEventListener('input', this.resizeTextarea)
        },
        beforeDestroy(){
            this.$el.removeEventListener('input', this.resizeTextarea)
        },

        /*render () {
            return this.$slots.default[0]
        },*/
    }
</script>


<style scoped>

</style>
